document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".helper-trigger");
  const popup = document.getElementById("helperPopup");
  const closeBtn = document.querySelector(".helper_close");

  if (trigger && popup) {
    const content = popup.querySelector(".helper_popup_content");

    // Open popup
    trigger.addEventListener("click", function () {
      popup.classList.add("active");
      document.body.classList.add("no-scroll");
    });

    // Close popup
    function closePopup() {
      // Smooth fade out
      content.style.transform = "translateY(-20px)";
      content.style.opacity = "0";
      popup.style.opacity = "0";
      document.body.classList.remove("no-scroll");

      // After transition ends, remove active class
      setTimeout(() => {
        popup.classList.remove("active");
        content.style.transform = ""; // reset
        content.style.opacity = "";
        popup.style.opacity = "";
      }, 300); // match CSS transition duration
    }

    closeBtn.addEventListener("click", closePopup);

    // Click outside content closes popup
    popup.addEventListener("click", function (e) {
      if (e.target === popup) closePopup();
    });
  }
});
